import React, { useState } from "react";
import styles from "./Footer.module.css";
import logo from "assets/svg/logo.svg";
import Modal from "components/common/Modal";
import { fnLink } from "function/fnLink";

const ready = process.env.PUBLIC_URL + "/svg/ready.svg";

export default function Footer() {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const table = [
        {
            idx: 0,
            name: "약관",
            list: [
                { idx: 0, name: "개인정보 처리방침", path: "/term/privacy" },
                { idx: 1, name: "위치정보 이용 약관", path: "/term/location" },
                { idx: 2, name: "서비스 이용 약관", path: "/term/service" }
            ]
        },
        {
            idx: 1,
            name: "회사",
            list: [
                { idx: 0, name: "서비스 소개", path: "/service" },
                { idx: 1, name: "사용가이드", path: "/guide" }
            ]
        },
        {
            idx: 2,
            name: "고객지원",
            list: [
                { idx: 0, name: "문의", path: "/contact" },
                { idx: 1, name: "앱 다운로드", action: () => fnLink() }
            ]
        }
    ];

    return (
        <div className={styles.footer}>
            <div className={styles.footerArea}>
                <div className={styles.footerContents}>
                    <div className={styles.logoWraper}>
                        <img src={logo} alt="logo" className={styles.logoFooter} />
                        <span>대표자 : 성호찬</span>
                        <span>사업자 등록번호 : 241-81-03704</span>
                        <span>주소 : 서울특별시 강남구 강남대로 374 케이스퀘어 강남2 B227</span>
                        <span>Mail : master@capl.co.kr</span>
                        <span>Fax : 0504-034-0395</span>
                    </div>

                    <div className={styles.FooterTable}>
                        {table.map((section) => (
                            <div key={section.idx} className={styles.footerColumn}>
                                <div className={styles.footerTitle}>{section.name}</div>
                                <div className={styles.footerList}>
                                    {section.list.map((item) => (
                                        <div
                                            key={item.idx}
                                            className={styles.footerItem}
                                            onClick={item.action}
                                        >
                                            {item.path ? (
                                                <a href={item.path} className={styles.footerLink}>
                                                    {item.name}
                                                </a>
                                            ) : (
                                                <div
                                                    className={styles.footerText}
                                                    style={{ cursor: item.action ? "pointer" : "default" }}
                                                >
                                                    {item.name}
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className={styles.cpText}>
                Copyright © 2026 Capl. All Rights Reserved.
            </div>

            {/* ✅ 공용 모달 사용 */}
            <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
                <img src={ready} style={{ width: "48px" }} alt="ready" />
                <p>앱 출시가 얼마 남지 않았어요!</p>
                <p>기대해 주세요 🚗</p>
            </Modal>
        </div>
    );
}
